import React from 'react'
import styled, { css } from 'styled-components'

const width = '27'
const height = '22.5'
const viewBox = '0 0 27 22.5'

const getDimensions = () => ({
  height,
  width
})

const getDimensionsCss = () => css`
  width: ${width}px;
  height: ${height}px;
`

const Image = styled.svg`
  ${({ noStyles }) => (!noStyles ? getDimensionsCss() : null)}
`

const defaultProps = {
  children: [
    <path
      key="1"
      d="M28.351,8.25a2.185,2.185,0,0,0-2.1-1.5H9.75a2.185,2.185,0,0,0-2.1,1.5L4.5,16.5V27.75A1.5,1.5,0,0,0,6,29.25H7.5A1.5,1.5,0,0,0,9,27.75V27H27v.75a1.5,1.5,0,0,0,1.5,1.5H30a1.5,1.5,0,0,0,1.5-1.5V16.5ZM9.75,22.5A2.25,2.25,0,1,1,12,20.25,2.21,2.21,0,0,1,9.75,22.5Zm16.5,0a2.25,2.25,0,1,1,2.25-2.25A2.21,2.21,0,0,1,26.25,22.5ZM7.5,15,9.75,9h16.5l2.25,6H7.5Z"
      transform="translate(-4.5 -6.75)"
      fill="#1E4F67"
    />
  ],
  viewBox
}

export default Object.assign(Image, {
  getDimensions,
  getDimensionsCss,
  defaultProps,
  displayName: 'IconCar'
})
